export interface IGroupedBarChartSubCategory {
	key: string;
	name: string;
	color: string;
}

export interface IGroupedBarChartCategory {
	name: string;
	color: string;
	key?: string;
	sub_categories?: Array<IGroupedBarChartSubCategory>;
}

export type IGroupedBarChartCellValue =
	| number
	| {
			value: number;
			sub_values?: Record<string, number>;
	  };

export interface IGroupedBarChartSeries {
	name: string;
	planograms_count?: number;
	values: Array<IGroupedBarChartCellValue>;
}

export interface IGroupedBarChartData {
	title: string;
	categories: Array<IGroupedBarChartCategory>;
	series: Array<IGroupedBarChartSeries>;
}

export function getGroupedBarChartCellTotal(cell: IGroupedBarChartCellValue | undefined): number {
	if (cell === undefined || cell === null) {
		return 0;
	}
	if (typeof cell === 'number') {
		return cell;
	}
	return cell.value ?? 0;
}

export function getGroupedBarChartSubValue(
	cell: IGroupedBarChartCellValue | undefined,
	subKey: string
): number {
	if (cell === undefined || cell === null || typeof cell === 'number') {
		return 0;
	}
	return cell.sub_values?.[subKey] ?? 0;
}
